export default __webpack_public_path__ + "static/media/eight.98202b95.svg";